import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedin,
  faYoutube   // ✅ ADDED
} from "@fortawesome/free-brands-svg-icons";

import {
  faEnvelope,
  faPenToSquare,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';

function NavbarComponent() {
  return (
    <div className="navbar-wrapper fixed-top">
      <Navbar collapseOnSelect expand="lg" className="custom-navbar" variant="dark">
        <Container>
          <Navbar.Brand
            className="brand-name"
            onClick={() => {
              const isLocal =
                window.location.hostname.includes('localhost') ||
                window.location.hostname.includes('127.0.0.1');

              const targetURL = isLocal
                ? window.location.origin
                : 'https://www.anubhavbangari.com';

              window.location.href = targetURL;
            }}
          >
            <h4>Anubhav Bangari</h4>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto nav-icons">

              {/* BLOG */}
              <Nav.Link href="/blog" title="Blogs" className="icon-link">
                <FontAwesomeIcon icon={faPenToSquare} size="lg" />
              </Nav.Link>

              {/* PROGRESS */}
              <Nav.Link href="/vision" title="Progress" className="icon-link">
                <FontAwesomeIcon icon={faChartLine} size="lg" />
              </Nav.Link>

              {/* ✅ YOUTUBE (NEW) */}
              <Nav.Link
                href="https://www.youtube.com/@anubhav.bangari"
                target="_blank"
                rel="noreferrer"
                title="YouTube"
                className="icon-link"
              >
                <FontAwesomeIcon icon={faYoutube} size="lg" />
              </Nav.Link>

              {/* LINKEDIN */}
              <Nav.Link
                href="https://www.linkedin.com/in/anubhav-bangari-6092bb1a3/"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <FontAwesomeIcon icon={faLinkedin} size="lg" />
              </Nav.Link>

              {/* INSTAGRAM */}
              <Nav.Link
                href="https://www.instagram.com/anubhav.bangari/"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </Nav.Link>

              {/* EMAIL */}
              <Nav.Link
                href="mailto:bangarianubhav@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <FontAwesomeIcon icon={faEnvelope} size="lg" />
              </Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default NavbarComponent;